import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Form } from "react-bootstrap";
import BondHeader from "../../Component/BondHeader/BondHeader";
import apiCall from "../../API/API";
import "./BondPaper.css";

const BondPaper = () => {
  const [bondData, setBondData] = useState("");
  const iframeRef = useRef(null);
  const [minor, setMinor] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    email: "",
    phone: "",
    applicantCode: "",
    panNumber: "",
    aadhaarNumber: "",
    minor: "N",
    depositAmount: "",
    period: "30 Months",
    amountInWords: "",
    investmentDate: "",
    maturityAmount: "",
    maturityInWords: "",
    maturityDate: "",
    accountNumber: "",
    bankName: "",
    ifscCode: "",
    branchName: "",
    agencyName: "",
    agencyCode: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // const handleBankInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     bankDetails: {
  //       ...formData.bankDetails,
  //       [name]: value,
  //     },
  //   });
  // };

  // const handleAgentInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({
  //     ...formData,
  //     agentDetails: {
  //       ...formData.agentDetails,
  //       [name]: value,
  //     },
  //   });
  // };

  const fetchData = async () => {
    try {
      const queryParams = {
        title: "bond_form",
      };
      const response = await apiCall(
        "GET",
        `/get_page?${new URLSearchParams(queryParams).toString()}`
      );
      setBondData(response?.data || ""); // Assuming data is HTML content
    } catch (error) {
      console.log("Error in fetching data", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (iframeRef.current && bondData) {
      const iframeDoc = iframeRef.current.contentWindow.document;
      iframeDoc.open();
      iframeDoc.write(bondData); // Inject bondData as HTML content
      iframeDoc.close();
    }
  }, [bondData]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key.toLowerCase() === "y") {
        setMinor("Y");
      } else if (event.key.toLowerCase() === "n") {
        setMinor("N");
      }
    };

    window.addEventListener("keypress", handleKeyPress);

    return () => {
      window.removeEventListener("keypress", handleKeyPress);
    };
  }, []);

  return (
    <React.Fragment>
      <Container>
        <BondHeader
          title="POLYBIONIC GROWTH PLAN"
          tagline="You Grow, We Grow"
          address="1st Floor, 227-L, Model Town, Karnal, Haryana 132001"
          phone="+91 9996262618 (Office)"
          website="metaftech.com"
        />
        <div className="form-content">
          <iframe
            ref={iframeRef}
            title="Bond Content"
            className="contentIframe"
          />
          <h5 className="text-center  heading">Schedule अनुसूची</h5>

          <div className="section">
            <Row>
              <Col md={7} style={{ paddingRight: "0px" }}>
                <div className="section">
                  <h6>APPLICANT DETAILS (आवेदक का विवरण)</h6>
                  <div className="section-details">
                    <Row>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "43px" }}>
                            <label className="formLab">Name :</label>
                            <label className="formL">नाम</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "53px" }}>
                            <label className="formLab">Address :</label>
                            <label className="formL">पता</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleInputChange}
                            style={{ height: "85px" }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="formData">
                              <div style={{ width: "45px" }}>
                                <label className="formLab">E-Mail :</label>
                                <label className="formL">ई-मेल</label>
                              </div>
                              <Form.Control
                                className="formInput"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleInputChange}
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="formData">
                              <div style={{ width: "94px" }}>
                                <label className="formLab">
                                  Phone Number :
                                </label>
                                <label className="formL">फोन नंबर</label>
                              </div>
                              <Form.Control
                                className="formInput"
                                type="text"
                                name="phone"
                                value={formData.phone}
                                onChange={handleInputChange}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col md={5} style={{ paddingLeft: "0px" }}>
                <div className="section">
                  <h6 style={{ padding: "18px" }}></h6>
                  <div className="section-details" style={{ height: "214px" }}>
                    <Row>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "96px" }}>
                            <label className="formLab">Applicant Code :</label>
                            <label className="formL">आवेदक का कोड</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="applicantCode"
                            value={formData.applicantCode}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "86px" }}>
                            <label className="formLab">PAN Number :</label>
                            <label className="formL">पैन नंबर</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="panNumber"
                            value={formData.panNumber}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "107px" }}>
                            <label className="formLab">Aadhaar Number :</label>
                            <label className="formL">आधार संख्या</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="aadhaarNumber"
                            value={formData.aadhaarNumber}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "49px" }}>
                            <label
                              className="formLab"
                              style={{ display: "flex" }}
                            >
                              Minor :
                            </label>
                            <label className="formL">नाबालिग</label>
                          </div>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <div
                              onClick={() => setMinor("Y")}
                              className="minorButton"
                              style={{
                                color: minor === "Y" ? "#000" : "grey",
                                fontWeight: minor === "Y" ? "600" : "normal",
                              }}
                            >
                              Y
                            </div>
                            <div
                              onClick={() => setMinor("N")}
                              className="minorButton"
                              style={{
                                color: minor === "N" ? "#000" : "grey",
                                fontWeight: minor === "N" ? "600" : "normal",
                              }}
                            >
                              N
                            </div>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className="section">
            <Row>
              <Col md={6} style={{ paddingRight: "0px" }}>
                <div className="section">
                  <div>
                    <h6>DEPOSIT DETAILS (जमा विवरण)</h6>
                  </div>
                  <div className="section-details">
                    <Row>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "98px" }}>
                            <label className="formLab">Deposit Amount :</label>
                            <label className="formL">जमा राशि</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="depositAmount"
                            value={formData.depositAmount}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "46px" }}>
                            <label className="formLab">Period :</label>
                            <label className="formL">अवधि</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="period"
                            value={formData.period}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "103px" }}>
                            <label className="formLab">Amount in words :</label>
                            <label className="formL">शब्दों में राशि</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="amountInWords"
                            value={formData.amountInWords}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "114px" }}>
                            <label className="formLab">
                              Date of Investment :
                            </label>
                            <label className="formL">निवेश की तिथि</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="investmentDate"
                            value={formData.investmentDate}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col md={6} style={{ paddingLeft: "0px" }}>
                <div className="section">
                  <div>
                    <h6>MATURITY DETAILS (परिपक्वता विवरण)</h6>
                  </div>
                  <div className="section-details" style={{ height: "216px" }}>
                    <Row>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "108px" }}>
                            <label className="formLab">Maturity Amount :</label>
                            <label className="formL">परिपक्वता राशि</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="maturityAmount"
                            value={formData.maturityAmount}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "108px" }}>
                            <label className="formLab">Amount in words :</label>
                            <label className="formL">शब्दों में राशि</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="maturityInWords"
                            value={formData.maturityInWords}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "106px" }}>
                            <label className="formLab">
                              Date of Maturity :
                            </label>
                            <label className="formL">परिपक्वता की तिथि</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="maturityDate"
                            value={formData.maturityDate}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>

          <div className="section">
            <Row>
              <Col md={7} style={{ paddingRight: "0px" }}>
                <div className="section">
                  <h6>BANK ACCOUNT DETAILS (बैंक खाता विवरण)</h6>
                  <div className="section-details">
                    <Row>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "104px" }}>
                            <label className="formLab">Account Number :</label>
                            <label className="formL">खाता संख्या</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="accountNumber"
                            value={formData.accountNumber}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "75px" }}>
                            <label className="formLab">Bank Name :</label>
                            <label className="formL">बैंक का नाम</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="bankName"
                            value={formData.bankName}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "85px" }}>
                            <label className="formLab">IFSC Code :</label>
                            <label className="formL">आईएफएससी कोड</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="ifscCode"
                            value={formData.ifscCode}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "92px" }}>
                            <label className="formLab">Branch Name :</label>
                            <label className="formL">शाखा का नाम</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="branchName"
                            value={formData.branchName}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
              <Col md={5} style={{ paddingLeft: "0px" }}>
                <div className="section">
                  <h6>AGENT DETAILS (एजेंट विवरण)</h6>
                  <div className="section-details" style={{ height: "216px" }}>
                    <Row>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "90px" }}>
                            <label className="formLab">Agency Name :</label>
                            <label className="formL">एजेंसी का नाम</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="agencyName"
                            value={formData.agencyName}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12}>
                        <Form.Group className="formData">
                          <div style={{ width: "82px" }}>
                            <label className="formLab">Agency Code :</label>
                            <label className="formL">एजेंसी कोड</label>
                          </div>
                          <Form.Control
                            className="formInput"
                            type="text"
                            name="agencyCode"
                            value={formData.agencyCode}
                            onChange={handleInputChange}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default BondPaper;
